
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement as reactElement_1 } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { createColumnDefinition, TextTableCell, ButtonTableCell, ImageTableCell, LabelTableCell, ComponentTableCell, DateTimeTableCell, DateTableCell, CheckboxTableCell, TableHeader, CheckboxTableHeader } from "./Table.js";
import { empty as empty_1, map as map_2, isEmpty, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { item as item_1, mapIndexed, tryItem, map, collect } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { FSharpMap__TryFind, FSharpMap__get_Item, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { setQueryParams, getColumnVisibilityObject, update as update_1, init as init_1 } from "./State.js";
import { TableMsg$1 } from "./Types.js";
import { useTranslation } from "react-i18next";
import { getSortedRowModel as getSortedRowModel_1, getFilteredRowModel as getFilteredRowModel_1, getCoreRowModel as getCoreRowModel_1, useReactTable } from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import { TextButton, SmallDropdownButton } from "../../Components/Button.js";
import { TableSettings, TableElementsCounter } from "./TableControlHeader.js";
import { IconInput } from "../../Components/Input.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { ColumnSelect } from "./ColumnSelect.js";
import { TableFilterDropDown } from "./CustomFilters.js";
import Compress from "../../../public/assets/icons/Compress.svg";
import Expand from "../../../public/assets/icons/Expand.svg";

export function InfiniteTableHead(props) {
    let elems;
    return reactElement_1("div", createObj(ofArray([["id", "table-head"], ["className", join(" ", ["row-start-1", "flex", "flex-row", "sticky", "top-0", "z-[1]"])], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = props.Options.RowSelection, (matchValue === "singleRow") ? singleton(createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })) : ((matchValue === "multiRow") ? singleton(createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })) : (empty()))), delay(() => ofArray(collect((x) => x, map((headerGroup) => map((header) => {
            let Key, Text$, ColumnFilter, matchValue_1, FilterValue, OnFilter, objectArg_1;
            return createElement(TableHeader, (($value) => { $value.key = $value.Key; return $value; })((Key = header.id, (Text$ = header.column.columnDef.header, (ColumnFilter = ((matchValue_1 = tryFind(header.id, props.ColumnDefinitionsMap), (matchValue_1 == null) ? "none" : matchValue_1.Filter)), (FilterValue = header.column.getFilterValue(), (OnFilter = ((objectArg_1 = header.column, (arg_1) => {
                objectArg_1.setFilterValue(arg_1);
            })), {
                BorderStyle: props.Options.BorderStyle,
                ColumnDefinitionMap: props.ColumnDefinitionsMap,
                ColumnFilter: ColumnFilter,
                ColumnId: header.id,
                FilterValue: FilterValue,
                Header: header,
                IsDraggable: props.IsDraggable,
                Key: Key,
                OnFilter: OnFilter,
                SetHeaderSize: true,
                SetQueryParams: props.Options.WithQueryParameters,
                StickyHeader: props.Options.StickyHeader,
                Table: props.Table,
                Text: Text$,
            })))))));
        }, headerGroup.headers), props.Table.getHeaderGroups())))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InfiniteBaseTable(props) {
    let elems_2, elems_1;
    const table = props.Table;
    const dependencies = [props.GlobalSearch];
    reactApi.useEffect(() => {
        const matchValue = props.GlobalSearch;
        if (matchValue == null) {
        }
        else {
            const globalSearch = matchValue;
            table.setGlobalFilter(globalSearch);
        }
    }, dependencies);
    const items = props.Virtualizer.getVirtualItems();
    return reactElement_1("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded-md", "w-full", "relative", "grid", "grid-rows-[auto,1fr]"])], ["style", {
        height: props.Virtualizer.getTotalSize(),
    }], (elems_2 = [createElement(InfiniteTableHead, {
        ColumnDefinitionsMap: props.ColumnDefinitionsMap,
        IsDraggable: props.IsHeaderDraggable,
        Options: {
            BorderStyle: props.Options.BorderStyle,
            ConfigurableColumns: props.Options.ConfigurableColumns,
            OnRowClick: unwrap(props.Options.OnRowClick),
            RowSelection: props.Options.RowSelection,
            StickyHeader: props.Options.StickyHeader,
            WithQueryParameters: props.Options.WithQueryParameters,
        },
        Table: table,
    }), reactElement_1("div", createObj(ofArray([["id", "table-body"], ["className", join(" ", ["absolute", "left-0", "w-full", "z-0", "row-start-2"])], ["style", {
        transform: ("translateY(" + defaultArg(map_1((item) => (item.start | 0), tryItem(0, items)), 0)) + "px)",
    }], (elems_1 = toList(delay(() => ofArray(mapIndexed((rowIndex, virtualItem) => {
        let elems;
        const row = item_1(virtualItem.index, table.getRowModel().rows);
        return reactElement_1("div", createObj(ofArray([["key", row.id], ["data-index", virtualItem.index], ["ref", (arg) => {
            props.Virtualizer.measureElement(arg);
        }], ["className", join(" ", toList(delay(() => append(singleton("group"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-row"), delay(() => ((props.Options.OnRowClick != null) ? singleton("hover:cursor-pointer") : empty()))))))))))], (elems = toList(delay(() => {
            let matchValue_1;
            return append((matchValue_1 = props.Options.RowSelection, (matchValue_1 === "multiRow") ? singleton(createElement(CheckboxTableCell, {
                BorderStyle: props.Options.BorderStyle,
                Checked: row.getIsSelected(),
                OnCheck: (arg_1) => {
                    row.toggleSelected(arg_1);
                },
                Row: row,
            })) : ((matchValue_1 === "singleRow") ? singleton(createElement(CheckboxTableCell, {
                BorderStyle: props.Options.BorderStyle,
                Checked: row.getIsSelected(),
                OnCheck: (arg_1) => {
                    row.toggleSelected(arg_1);
                },
                Row: row,
            })) : (empty()))), delay(() => map((cell) => {
                const columnDefinition = FSharpMap__get_Item(props.ColumnDefinitionsMap, cell.column.id);
                const matchValue_2 = columnDefinition.AccessorFunction(row.original);
                switch (matchValue_2.tag) {
                    case 6:
                        return createElement(DateTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Date: unwrap(matchValue_2.fields[0]),
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                            TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                        });
                    case 7:
                        return createElement(DateTimeTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Date: matchValue_2.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        });
                    case 1:
                        return createElement(ComponentTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Component: matchValue_2.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        });
                    case 3:
                        return createElement(LabelTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Labels: matchValue_2.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        });
                    case 4:
                        return createElement(ImageTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            ImageUrls: singleton_1({
                                ImageUrl: matchValue_2.fields[0],
                                Position: 1,
                            }),
                            Row: row,
                        });
                    case 5:
                        return createElement(ImageTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            ImageUrls: matchValue_2.fields[0],
                            Row: row,
                        });
                    case 2:
                        return createElement(ButtonTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            ButtonContent: {
                                Label: matchValue_2.fields[0],
                                OnClick: matchValue_2.fields[1],
                            },
                            Cell: cell,
                            Row: row,
                        });
                    default:
                        return createElement(TextTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                            TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                            Text: matchValue_2.fields[0],
                        });
                }
            }, row.getVisibleCells())));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, items)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function InfiniteTable(props) {
    let getCoreRowModel, getFilteredRowModel, getSortedRowModel, state_2, enableRowSelection, matchValue, matchValue_1, elems_6;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.TableKey, props.Options.SaveTableConfiguration, props.Options.DefaultColumnFilter, props.Options.DefaultSortColumn, props.Options.WithQueryParameters, props.ColumnDefinitions), update_1, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const dependencies_2 = [props.ColumnDefinitions];
    reactApi.useEffect(() => {
        dispatch(new TableMsg$1(0, [props.ColumnDefinitions]));
    }, dependencies_2);
    const patternInput_1 = useTranslation();
    const dependencies_4 = [state_1.IsFullscreen];
    reactApi.useEffect(() => {
        if (props.Options.Fullscreen) {
            document.addEventListener("keydown", (e) => {
                if ((e.key === "Escape") && state_1.IsFullscreen) {
                    dispatch(new TableMsg$1(4, []));
                }
            });
        }
    }, dependencies_4);
    const columnDefinition = createColumnDefinition(props.ColumnDefinitions, state_1.ColumnFilters);
    const table = useReactTable((getCoreRowModel = getCoreRowModel_1(), (getFilteredRowModel = getFilteredRowModel_1(), (getSortedRowModel = getSortedRowModel_1(), (state_2 = {
        columnFilters: state_1.ColumnFilters,
        columnOrder: state_1.ColumnOrder,
        columnVisibility: getColumnVisibilityObject(props.ColumnDefinitions, state_1.VisibleColumns),
        rowSelection: state_1.SelectedRows,
        sorting: state_1.ColumnSorting,
    }, (enableRowSelection = ((matchValue = props.Options.RowSelection, (matchValue === "singleRow") ? true : (matchValue === "multiRow"))), {
        columnResizeMode: "onChange",
        columns: columnDefinition,
        data: props.TableRows,
        debugTable: false,
        defaultColumn: {
            maxSize: 10000,
            minSize: 75,
            size: 200,
        },
        enableGlobalFilter: true,
        enableMultiRowSelection: (matchValue_1 = props.Options.RowSelection, (matchValue_1 === "singleRow") ? false : (matchValue_1 === "multiRow")),
        enableRowSelection: enableRowSelection,
        enableSortingRemoval: false,
        getCoreRowModel: getCoreRowModel,
        getFilteredRowModel: getFilteredRowModel,
        getSortedRowModel: getSortedRowModel,
        onColumnFiltersChange: (filterUpdater) => {
            dispatch(new TableMsg$1(5, [filterUpdater(state_1.ColumnFilters)]));
        },
        onColumnOrderChange: (arg) => {
            dispatch(new TableMsg$1(9, [arg]));
        },
        onColumnVisibilityChange: (visibilityUpdater) => {
            dispatch(new TableMsg$1(8, [visibilityUpdater(getColumnVisibilityObject(state_1.ColumnDefinitions, state_1.VisibleColumns))]));
        },
        onRowSelectionChange: (rowSelectionUpdater) => {
            dispatch(new TableMsg$1(2, [rowSelectionUpdater(state_1.SelectedRows)]));
        },
        onSortingChange: (sortingUpdater) => {
            dispatch(new TableMsg$1(7, [sortingUpdater(state_1.ColumnSorting)]));
        },
        state: state_2,
    }))))));
    const parentRef = reactApi.useRef(undefined);
    const rowVirtualizer = useVirtualizer({
        count: table.getRowModel().rows.length,
        estimateSize: (_arg_5) => 50,
        getScrollElement: (_arg_4) => parentRef.current,
        overscan: 20,
    });
    return reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => (state_1.IsFullscreen ? append(singleton("fixed"), delay(() => append(singleton("inset-0"), delay(() => append(singleton("z-[15]"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => singleton("pt-6"))))))))))))) : singleton("h-[calc(100%-40px)]")))))], (elems_6 = toList(delay(() => {
        let elems_4, elems, elems_3;
        return append(((((!isEmpty(props.Controls) ? true : props.Options.ConfigurableColumns) ? true : props.Options.GlobalSearch) ? true : props.Options.CSVDownload) ? true : props.Options.Fullscreen) ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("px-6"), delay(() => append(singleton("top-[0px]"), delay(() => append(singleton("left-1"), delay(() => append(singleton("bg-[#fefefe]"), delay(() => append(singleton("z-10"), delay(() => {
            const matchValue_2 = props.Options.BorderStyle;
            switch (matchValue_2) {
                case "full":
                case "none": {
                    return empty();
                }
                default:
                    return append(singleton("border-b"), delay(() => singleton("border-border")));
            }
        })))))))))))))))], (elems_4 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "grow"])], (elems = toList(delay(() => map_2((control) => {
            let OnClick, matchValue_3, onClick, array_2;
            if (control.tag === 1) {
                return createElement(SmallDropdownButton, {
                    Classes: empty_1(),
                    ComponentState: "enabled",
                    DisplayArrow: true,
                    DisplayDivider: false,
                    Elements: map_2((tableControl_1) => {
                        let array_5;
                        let OnClick_1;
                        const matchValue_4 = tableControl_1.OnClick;
                        if (matchValue_4 == null) {
                            OnClick_1 = (() => {
                            });
                        }
                        else {
                            const onClick_1 = matchValue_4;
                            OnClick_1 = (() => {
                                onClick_1(ofArray(map((row_1) => row_1.original, table.getSelectedRowModel().rows)));
                                table.toggleAllRowsSelected(false);
                            });
                        }
                        return {
                            ComponentState: tableControl_1.EnabledOnlyOnSelection ? (((array_5 = table.getSelectedRowModel().rows, array_5.length === 0)) ? "disabled" : "enabled") : "enabled",
                            DisplayName: tableControl_1.Label,
                            Icon: unwrap(tableControl_1.Icon),
                            OnClick: OnClick_1,
                        };
                    }, control.fields[1]),
                    Label: control.fields[0],
                    TestId: "",
                });
            }
            else {
                const tableControl = control.fields[0];
                return createElement(TextButton, (OnClick = ((matchValue_3 = tableControl.OnClick, (matchValue_3 == null) ? (() => {
                }) : ((onClick = matchValue_3, () => {
                    onClick(ofArray(map((row) => row.original, table.getSelectedRowModel().rows)));
                    table.toggleAllRowsSelected(false);
                })))), {
                    ComponentState: tableControl.EnabledOnlyOnSelection ? (((array_2 = table.getSelectedRowModel().rows, array_2.length === 0)) ? "disabled" : "enabled") : "enabled",
                    Icon: unwrap(tableControl.Icon),
                    Label: tableControl.Label,
                    OnClick: OnClick,
                    TestId: "",
                    Variant: "default",
                }));
            }
        }, props.Controls))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "py-5"])], (elems_3 = toList(delay(() => append(singleton(createElement(TableElementsCounter, {
            NumberOfElements: table.getRowModel().rows.length,
        })), delay(() => append(props.Options.GlobalSearch ? singleton(createElement(IconInput, {
            ComponentState: "enabled",
            LeftIcon: Magnifying_Glass(),
            OnChange: (globalSearchValue) => {
                if (props.Options.WithQueryParameters) {
                    setQueryParams("global-search", globalSearchValue);
                }
                dispatch(new TableMsg$1(1, [globalSearchValue]));
            },
            TestId: "",
            Value: state_1.GlobalSearchPattern,
        })) : empty(), delay(() => append(props.Options.ConfigurableColumns ? singleton(createElement(ColumnSelect, {
            ButtonLabel: patternInput_1[0]("table.columns"),
            ComponentState: "enabled",
            Items: ofArray(map((column) => {
                let matchValue_5;
                const Id = column.columnDef.id;
                return {
                    Checked: column.getIsVisible(),
                    Group: (matchValue_5 = FSharpMap__TryFind(state_1.ColumnDefinitionMap, column.id), (matchValue_5 == null) ? "" : matchValue_5.Group),
                    Id: Id,
                    Name: column.columnDef.header,
                    OnCheck: (_arg_8) => {
                        column.toggleVisibility(!column.getIsVisible());
                    },
                };
            }, table.getAllLeafColumns())),
            TestId: "infinite-table-columm-select",
        })) : empty(), delay(() => append((props.Options.CustomTableFilters ? true : (props.FilterDropDownElements != null)) ? singleton(createElement(TableFilterDropDown, {
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            ColumnFilters: state_1.ColumnFilters,
            CustomTableFilters: props.Options.CustomTableFilters,
            Dispatch: dispatch,
            FilterDropDown: unwrap(props.FilterDropDownElements),
            SavedFilters: state_1.SavedFilters,
        })) : empty(), delay(() => append(singleton(createElement(TableSettings, {
            CSVDownloadActivated: props.Options.CSVDownload,
            CSVDownloadRunning: state_1.CSVDownloadRunning,
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            Dispatch: dispatch,
            ResetConfigurationEnabled: props.Options.SaveTableConfiguration,
            ResetFilterEnabled: props.ColumnDefinitions.some((columnDefinition_1) => (columnDefinition_1.Filter !== "none")),
            Table: table,
        })), delay(() => {
            let elems_2, elems_1;
            return props.Options.Fullscreen ? singleton(reactElement_1("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "cursor-pointer"])], ["onClick", (_arg_9) => {
                dispatch(new TableMsg$1(4, []));
            }], (elems_2 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_1 = toList(delay(() => (state_1.IsFullscreen ? singleton(Compress()) : singleton(Expand())))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
        })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
            let elems_5;
            return singleton(reactElement_1("div", createObj(ofArray([["ref", parentRef], ["className", join(" ", toList(delay(() => append(state_1.IsFullscreen ? singleton("flex-1") : singleton("h-[calc(100%-80px)]"), delay(() => append(singleton("overflow-auto"), delay(() => singleton("bg-white"))))))))], (elems_5 = [createElement(InfiniteBaseTable, {
                ColumnDefinitions: props.ColumnDefinitions,
                ColumnDefinitionsMap: state_1.ColumnDefinitionMap,
                GlobalSearch: state_1.GlobalSearchPattern,
                IsHeaderDraggable: props.Options.SaveTableConfiguration,
                Options: {
                    BorderStyle: props.Options.BorderStyle,
                    ConfigurableColumns: props.Options.ConfigurableColumns,
                    OnRowClick: unwrap(props.Options.OnRowClick),
                    RowSelection: props.Options.RowSelection,
                    StickyHeader: true,
                    WithQueryParameters: props.Options.WithQueryParameters,
                },
                Table: table,
                TableRows: props.TableRows,
                Virtualizer: rowVirtualizer,
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

